import { useTranslation } from "react-i18next";

// Bundle this display label because the API translation catalog may not contain it yet.
export default function useCyrafaPaymentLabel() {
  const { i18n } = useTranslation();
  const language = (i18n.language || "en").toLowerCase().split(/[-_]/)[0];

  return language === "ar"
    ? "الدفع بالعملات الرقمية (USDT)"
    : "Crypto Payment (USDT)";
}
